import { useEffect } from 'react';

const SELECTOR = [
  '.section__head',
  '.pillar',
  '.card',
  '.vs__col',
  '.vs__badge',
  '.team__member',
  '.stat',
  '.pulse-row',
  '.quote-band',
  '.featured',
  '.callout',
  '.article__body > p',
  '.section > .container > .btn',
  '.section > .container > .magnetic',
].join(',');

function variantFor(el) {
  if (el.classList.contains('vs__col--old')) return 'reveal-left';
  if (el.classList.contains('vs__col--new')) return 'reveal-right';
  if (el.classList.contains('vs__badge')) return 'reveal-scale';
  return '';
}

export default function useScrollReveal(dep) {
  useEffect(() => {
    const reduced =
      typeof matchMedia !== 'undefined' && matchMedia('(prefers-reduced-motion: reduce)').matches;

    const io =
      !reduced && typeof IntersectionObserver !== 'undefined'
        ? new IntersectionObserver(
            (entries, obs) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-in');
                  obs.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
          )
        : null;

    const prep = (el) => {
      if (el.classList.contains('is-in')) return;

      if (reduced || !io) {
        el.classList.add('reveal-auto', 'is-in');
        return;
      }

      if (!el.dataset.rvl) {
        el.dataset.rvl = '1';
        const variant = variantFor(el);
        el.classList.add('reveal-auto');
        if (variant) el.classList.add(variant);
        const parent = el.parentElement || document.body;
        const n = parent.__rvlCount || 0;
        el.style.transitionDelay = `${Math.min(n, 6) * 80}ms`;
        parent.__rvlCount = n + 1;
      }

      io.observe(el);
    };

    const scan = () => document.querySelectorAll(SELECTOR).forEach(prep);
    scan();

    let raf = 0;
    const mo = new MutationObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(scan);
    });
    const root = document.getElementById('main') || document.body;
    mo.observe(root, { childList: true, subtree: true });

    return () => {
      cancelAnimationFrame(raf);
      mo.disconnect();
      if (io) io.disconnect();
    };
  }, [dep]);
}
